export function TTYList({ items }: { items: string[] }) {
  return (
    <div className="w-[200px]">
      {items.map((line) => (
        <span className="block" key={line}>
          {line}
        </span>
      ))}
    </div>
  );
}
